const c = {
  name: "SecurityCamera",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,27.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.7,26.7,19.3,27.2,20,27.2z"
			/>
		<path class="st0" d="M20,21c-2.8,0-5,2.2-5,5c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5C25,23.2,22.8,21,20,21z M17,26c0-1.7,1.3-3,3-3
			c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C18.3,29,17,27.7,17,26z"/>
		<path class="st0" d="M36.2,5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C35.7,3.8,36.2,4.3,36.2,5z"/>
		<path class="st0" d="M0,0h40v15h-6v11c0,4.3-1.9,8.2-5,10.7v0L28.7,37c0,0-0.1,0-0.1,0.1c-2.4,1.9-5.4,3-8.6,3
			c-3.3,0-6.2-1.1-8.6-3c0,0-0.1,0-0.1-0.1L11,36.7v0C7.9,34.2,6,30.3,6,26V15H0V0z M32,26V15H8v11c0,3,1.1,5.8,3,7.9V26
			c0-5,4-9,9-9c2.5,0,4.7,1,6.4,2.6l0,0C28,21.3,29,23.5,29,26v7.9C30.9,31.8,32,29,32,26z M20,38c2.4,0,4.7-0.7,6.6-2
			c0.1-0.1,0.3-0.2,0.4-0.3V26c0-1.9-0.8-3.7-2-5c-1.3-1.3-3-2-5-2c-3.9,0-7,3.1-7,7v9.7C15,37.2,17.4,38,20,38z M38,13v-3H2v3H38z
			 M2,2v6h36V2H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as SecurityCamera
};
